module.exports = __webpack_public_path__ + "img/moment.415ddee0.png";